import React from "react";

const TicketGuideline = () => {
  return (
    <div className="max-w-6xl mx-auto px-4 py-10 space-y-10">
      {/* Heading */}
      <h1 className="text-3xl font-bold flex items-center gap-2">
        📝 Ticket Module Guidelines
      </h1>

      {/* Guidelines Card */}
      <div className="bg-white rounded-2xl shadow-md p-6 space-y-4 border">
        <ul className="list-disc pl-5 space-y-3 text-gray-800">
          <li>
            <strong>Keep the title short and clear</strong>
            <br />
            <span className="text-gray-600">
              Example: "Unable to access dashboard"
            </span>
          </li>
          <li>
            <strong>Explain the issue clearly in the description</strong>
            <br />
            <span className="text-gray-600">
              Example: "When trying to log into the dashboard on Chrome browser,
              I receive a 403 error."
            </span>
          </li>
          <li>
            <strong>Check your ticket regularly</strong>
            <br />
            Monitor for replies or updates from support.
          </li>
          <li>
            <strong>Use the chat option if needed</strong>
            <br />
            Use the built-in chat for quicker communication.
          </li>
          <li>
            <strong>Mark the ticket as resolved when the issue is fixed</strong>
            <br />
            Use the ‘Mark as Resolved’ button at the top right corner.
          </li>
          <li>
            <strong>Reopen the ticket if the issue persists</strong>
            <br />
            Use the ‘Reopen Ticket’ option if needed.
          </li>
          <li>
            <strong>Choose the correct category</strong>
            <br />
            Pick the most relevant category for your issue.
          </li>
          <li>
            <strong>Save the operations team’s contact info</strong>
            <br />
            Keep their contact handy for important updates.
          </li>
        </ul>
      </div>

      {/* Categories */}
      <div className="space-y-8">
        <h2 className="text-2xl font-semibold flex items-center gap-2">
          🎫 LMS Ticket Categories & Clarifications
        </h2>

        <div className="grid md:grid-cols-2 gap-6">
          {categories.map((cat, idx) => (
            <div
              key={idx}
              className="bg-gray-50 rounded-xl shadow border p-5 space-y-2 hover:shadow-lg transition"
            >
              <h3 className="text-lg font-semibold flex items-center gap-2">
                {cat.icon} {cat.title}
              </h3>
              <ul className="list-disc pl-5 text-sm text-gray-700 space-y-1">
                {cat.points.map((point, i) => (
                  <li key={i}>{point}</li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default TicketGuideline;

const categories = [
  {
    title: "Curriculum Issues",
    icon: "📚",
    points: [
      "Unclear syllabus or course structure",
      "Mismatch between course topics and assessments",
      "Difficulty understanding course materials",
    ],
  },
  {
    title: "Academic Support",
    icon: "🧑‍🏫",
    points: [
      "Requests for tutoring or mentorship",
      "Help with assignments or projects",
      "Clarifications on grading criteria or exam patterns",
    ],
  },
  {
    title: "Leave Requests",
    icon: "📝",
    points: [
      "Note: Raise a ticket only if the leave exceeds 2 days.",
      "Absence due to medical or personal reasons",
    ],
  },
  {
    title: "LMS Support",
    icon: "💻",
    points: [
      "Issues accessing courses or study materials",
      "Login/account-related problems",
      "Navigation difficulties within the LMS",
      "Broken links or missing files in the course content",
    ],
  },
  {
    title: "General Help",
    icon: "❓",
    points: [
      "Queries not covered under any other category",
      "Guidance on effectively using the LMS features",
    ],
  },
  {
    title: "Counseling Services",
    icon: "🧠",
    points: [
      "Career guidance and academic planning",
      "Mental health and emotional well-being support",
      "Time management and study strategies",
    ],
  },
  {
    title: "Technical Issues",
    icon: "⚙️",
    points: [
      "Website or app bugs",
      "Video buffering/streaming problems",
      "Compatibility issues with browsers or devices",
      "Errors while submitting assignments or raising tickets",
    ],
  },
  {
    title: "Feedback & Suggestions",
    icon: "💬",
    points: [
      "Feedback on LMS functionality and user experience",
      "Complaints or appreciation related to faculty or content",
    ],
  },
];
